import { Component } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule,NgxSpinnerModule,],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  [x: string]: any;
  title = 'timesheet';
  constructor(
    private location: LocationStrategy
  ) {
    // The following history manipulation can interfere with Angular Router.
    // It's generally not needed and can be removed unless there's a specific requirement.
    // history.pushState(null, null, window.location.href);
    // this.location.onPopState(() => {
    //     history.pushState(null, null, window.location.href);
    // });
  }
}
